import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/AuthContext';
import { getFunctions, httpsCallable } from 'firebase/functions';
import toast from 'react-hot-toast';

const BecomeOrganiserPage = () => {
  const navigate = useNavigate();
  const { user, refreshProfile } = useAuth();
  const [form, setForm] = useState({ orgName: '', orgType: '', description: '' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!form.orgName || !form.orgType) { toast.error('Please fill in all required fields'); return; }
    setLoading(true);
    try {
      const functions = getFunctions(undefined, 'europe-west1');
      const selfRegister = httpsCallable(functions, 'selfRegisterOrganiser');
      await selfRegister({ orgName: form.orgName, orgType: form.orgType, description: form.description });
      await user.getIdToken(true);
      await refreshProfile();
      toast.success('Welcome to Gather as an organiser! 🎉');
      setTimeout(() => navigate('/organiser'), 1500);
    } catch (err) {
      console.error(err);
      toast.error('Something went wrong – please try again');
    }
    setLoading(false);
  };

  return (
    <div style={s.page}>
      <button onClick={() => navigate('/profile')} style={s.back}>← Back</button>
      <h1 style={s.title}>Become an Organiser</h1>
      <p style={s.subtitle}>Post events for your community. Free, fast, and simple.</p>
      <div style={s.card}>
        <label style={s.label}>Organisation or Group Name *</label>
        <input style={s.input} placeholder="e.g. Loughrea GAA, St Brendan's NS, Loughrea Tidy Towns" value={form.orgName} onChange={e => setForm({ ...form, orgName: e.target.value })} />
        <label style={s.label}>Type of Organisation *</label>
        <select style={s.input} value={form.orgType} onChange={e => setForm({ ...form, orgType: e.target.value })}>
          <option value="">Select one...</option>
          <option value="sports">Sports Club</option>
          <option value="community">Community Group</option>
          <option value="school">School</option>
          <option value="church">Church / Parish</option>
          <option value="business">Business</option>
          <option value="charity">Charity / Voluntary</option>
          <option value="arts">Arts / Culture</option>
          <option value="other">Other</option>
        </select>
        <label style={s.label}>What events do you run? (optional)</label>
        <textarea style={{ ...s.input, height: 80, resize: 'none' }} placeholder="e.g. Weekly training sessions, monthly markets, annual festivals..." value={form.description} onChange={e => setForm({ ...form, description: e.target.value })} />
      </div>
      <button style={{ ...s.btn, opacity: loading ? 0.7 : 1 }} onClick={handleSubmit} disabled={loading}>
        {loading ? 'Setting up your account...' : 'Register as Organiser 🌿'}
      </button>
      <p style={s.note}>By registering you agree to post accurate, community-friendly events only.</p>
    </div>
  );
};

const s = {
  page: { padding: '24px 20px 40px', maxWidth: 430, margin: '0 auto', background: '#fff', minHeight: '100vh' },
  back: { background: 'none', border: 'none', color: '#1A7A4A', fontSize: 15, fontWeight: 600, cursor: 'pointer', marginBottom: 20, padding: 0 },
  title: { fontSize: 26, fontWeight: 800, color: '#2C342C', marginBottom: 8 },
  subtitle: { fontSize: 15, color: '#5E6F5E', marginBottom: 28, lineHeight: 1.5 },
  card: { background: '#F8FBF8', borderRadius: 16, padding: 20, marginBottom: 20 },
  label: { display: 'block', fontSize: 13, fontWeight: 700, color: '#2C342C', marginBottom: 6, marginTop: 16 },
  input: { width: '100%', padding: '12px 14px', borderRadius: 10, border: '1.5px solid #C8D9C9', fontSize: 15, fontFamily: 'Nunito, sans-serif', background: '#fff', boxSizing: 'border-box' },
  btn: { width: '100%', padding: '16px', background: '#1A7A4A', color: '#fff', border: 'none', borderRadius: 14, fontSize: 16, fontWeight: 800, cursor: 'pointer' },
  note: { fontSize: 12, color: '#5E6F5E', textAlign: 'center', marginTop: 16 },
};

export default BecomeOrganiserPage;
